/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue'
import VueCardFormat from 'vue-credit-card-validation'
import VueSimpleAlert from 'vue-simple-alert'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import VueYoutube from 'vue-youtube'
import Draggable from 'vuedraggable'
import '@mdi/font/css/materialdesignicons.css'
import vSelect from 'vue-select'
import router from './routes'
import store from './store'
import { registerGlobalFilters } from '../logic/format'
import cmap from '../logic/cmap'
import vIntersect from '../directives/intersect'
import 'vue-select/dist/vue-select.css'

require('../bootstrap')

Vue.use(VueSimpleAlert)
Vue.config.productionTip = false
window.Vue = Vue

Vue.mixin(cmap)
Vue.directive('intersect', vIntersect)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component(
  'main-container',
  require('./components/MainContainer.vue').default,
)

Vue.use(VueCardFormat)
Vue.use(VModal)
Vue.use(VTooltip)
Vue.use(Draggable)
Vue.use(VueYoutube)
Vue.component('v-select', vSelect)
Vue.directive('tooltip', VTooltip.VTooltip)
VTooltip.options.defaultTemplate = '<div class="tooltip2" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'

registerGlobalFilters()

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: '#app',
  router,
  store,
  VueSimpleAlert,
})

export default app
